import { CheckBoxFormWrap, CustomCheckBox } from '@/styles/common/CommonForm/checkboxForm'

const CheckBoxForm = (props: any) => {
  const { onChange, checked, data, onSuccess } = props
  return (
    <CheckBoxFormWrap>
      {data?.map((option: any) => (
        <section key={option?.text}>
          <CustomCheckBox
            type={'checkbox'}
            onChange={() => {
              onChange(option?.idx)
              onSuccess !== undefined && onSuccess()
            }}
            checked={checked === option?.idx}
          />
          <label
            htmlFor=""
            onClick={() => {
              onChange(option?.idx)
              onSuccess !== undefined && onSuccess()
            }}
          >
            {option?.text}
          </label>
        </section>
      ))}
    </CheckBoxFormWrap>
  )
}
export default CheckBoxForm
